import { mapState } from 'vuex'
import { get } from 'lodash'

import en from '../locales/en.json'
import ru from '../locales/ru.json'
import ua from '../locales/ua.json'
import kz from '../locales/kz.json'
import es from '../locales/es.json'

export default {
  data () {
    return {
      focused: false
    }
  },
  methods: {
    en () {
      this.$store.commit('SET_LANG', 'en')
      this.$store.dispatch('lang', 'en')
    },
    ru () {
      this.$store.commit('SET_LANG', 'ru')
      this.$store.dispatch('lang', 'ru')
    },
    ua () {
      this.$store.commit('SET_LANG', 'ua')
      this.$store.dispatch('lang', 'ua')
    },
    kz () {
      this.$store.commit('SET_LANG', 'kz')
      this.$store.dispatch('lang', 'kz')
    },
    es () {
      this.$store.commit('SET_LANG', 'es')
      this.$store.dispatch('lang', 'es')
    },
    $onInput (e, prop) {
      const data = {
        section: this.section,
        language: this.$store.state.lang,
        property: prop,
        value: e.target.innerHTML || e.target.value
      }

      this.$store.commit('MODIFY_TRANSLATE', data)
    },
    $onFocus (e, prop) {
      e.target.innerHTML = get(this.tr, prop)
      this.focused = true
    },
    $onBlur (e) {
      this.focused = false
    }
  },
  computed: {
    ...mapState(['footer', 'header', 'ip', 'is', 'it', 'main']),
    lang () {
      return this.$store.state.lang
    },
    lang_switips () {
      return this.$store.state.lang
    },
    englishVersion () {
      return this.$store.state.lang === 'en'
    },
    mexicoVersion () {
      return this.$store.state.lang === 'es'
    },
    lang_switips_link () {
      if (this.$store.state.lang === 'kz') {
        return 'kk'
      }

      if (this.$store.state.lang === 'ua') {
        return 'uk'
      }

      return this.$store.state.lang
    },
    tr () {
      if (this.lang === 'ru') {
        return ru[this.section]
      }
      if (this.lang === 'ua') {
        return ua[this.section]
      }
      if (this.lang === 'kz') {
        return kz[this.section]
      }
      if (this.lang === 'es') {
        return es[this.section]
      }
      return en[this.section]
    },
    canIedit () {
      return false
    }
  }
}
